/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Effect_MaintainingInputs */

const en_ui_te_effect_maintaining = /** @type {(inputs: Ui_Te_Effect_MaintainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintaining`)
};

const de_ui_te_effect_maintaining = /** @type {(inputs: Ui_Te_Effect_MaintainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erhaltend`)
};

/**
* | output |
* | --- |
* | "Maintaining" |
*
* @param {Ui_Te_Effect_MaintainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_effect_maintaining = /** @type {((inputs?: Ui_Te_Effect_MaintainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Effect_MaintainingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_effect_maintaining(inputs)
	return de_ui_te_effect_maintaining(inputs)
});